import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const NotFound = () => {
  const { language } = useLanguage();
  const isId = language === 'id';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 text-center">
      {/* 404 number */}
      <div className="relative mb-6">
        <span className="text-[10rem] font-black text-gray-100 leading-none select-none">404</span>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="bg-white border border-gray-200 rounded-2xl px-6 py-3 shadow-sm">
            <span className="text-2xl font-bold bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">
              {isId ? 'Halaman Tidak Ditemukan' : 'Page Not Found'}
            </span>
          </div>
        </div>
      </div>

      <p className="text-gray-500 text-base max-w-md mb-8">
        {isId
          ? 'Halaman yang Anda cari tidak ada atau sudah dipindahkan. Kembali ke beranda dan jelajahi portofolio saya.'
          : "The page you're looking for doesn't exist or has been moved. Head back home and explore my portfolio."}
      </p>

      <div className="flex flex-col sm:flex-row items-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-6 py-3 rounded-xl transition-colors shadow-md shadow-emerald-500/20"
        >
          <Home size={16} />
          {isId ? 'Kembali ke Beranda' : 'Back to Home'}
        </Link>
        <button
          onClick={() => window.history.back()}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 font-semibold px-6 py-3 rounded-xl border border-gray-200 hover:border-gray-300 bg-white transition-colors"
        >
          <ArrowLeft size={16} />
          {isId ? 'Halaman Sebelumnya' : 'Go Back'}
        </button>
      </div>

      {/* decorative dots */}
      <div className="mt-16 grid grid-cols-5 gap-2 opacity-20">
        {Array.from({ length: 25 }).map((_, i) => (
          <div key={i} className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
        ))}
      </div>
    </div>
  );
};

export default NotFound;
